import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/widgets/CartList/ui/CartList.tsx");
